goog.provide('el8.uiwidget.Drawer');

goog.require('el8.template.uiwidget.Drawer');


/**
 * The "Drawer" emerges out of a dialog (like a drawer)
 * cover some additional detail. It partners with the DrawerDialog.
 *
 * We use it for med history (the drawer contains details on a single med,
 * while the main dialog contains details on the thread, e.g.).
 */
el8.uiwidget.Drawer = function(spec) {

    spec = spec || {};

    this._width = spec.width || 200;
    this._height = spec.height || 400;

    // For sliding open to the right
    this._leftOffsets = null;
    if (spec.leftOffsets) {
        this._leftOffsets = {
            start: spec.leftOffsets.start,
            end: spec.leftOffsets.end
        };
    }

    this._contentFn = spec.contentFn || null;

    /** Holds state **/
    this._isInit = false;
    this._isShowing = false;

};
el8.uiwidget.Drawer.prototype._init = function() {
    if (this._isInit) { return; }
    if (this._contentFn) { this._contentElt.html(this._contentFn()); }
    this._isInit = true;
};
el8.uiwidget.Drawer.prototype.attachTo = function($elt) {
    this._container = $(el8.template.uiwidget.Drawer.container()).hide();
    $elt.append(this._container);
    this._contentElt = $('.drawer-content', this._container);
};


/**
 * Show/hide will always animate
 */
el8.uiwidget.Drawer.prototype.show = function() {
    if (!this._isInit) { this._init(); }
    if (this._leftOffsets) {
        this._container.css('left', this._leftOffsets.start);
        this._container.show();
        this.adjustSize();
        this._container.animate({
            'left': this._leftOffsets.end
        });
    } else {
        this._container.show();
        this.adjustSize();
    }
    this._isShowing = true;
};
el8.uiwidget.Drawer.prototype.hide = function() {
    if (this._leftOffsets) {
        this._container.animate({
            'left': this._leftOffsets.start
        });
    } else {
        this._container.hide();
    }
    this._isShowing = false;
};
el8.uiwidget.Drawer.prototype.isShowing = function() {
    return this._isShowing;
};
el8.uiwidget.Drawer.prototype.adjustSize = function() {
    var height = jQuery.isFunction(this._height) ? this._height() : this._height;
    this._container.outerWidth(jQuery.isFunction(this._width) ? this._width() : this._width);
    this._container.outerHeight(height);
    var $content = this.getContentElt();
    var paddingHeight = $content.outerHeight(true) - $content.height();
    $content.outerHeight(height - paddingHeight);
};
el8.uiwidget.Drawer.prototype.getContainer = function() {
    return this._container;
};
el8.uiwidget.Drawer.prototype.getContentElt = function() {
    return $('.drawer-content', this._container);
};

